<h2 mat-dialog-title>{{ data.title }}</h2>

<div mat-dialog-content [innerHTML]="data.message"></div>

<div mat-dialog-actions>
    <button mat-stroked-button [mat-dialog-close]="false" cdkFocusInitial>
        {{ data.cancelButtonLabel ?? 'Cancel' }}
    </button>

    @if (data.type === 'confirm') {
        <button mat-raised-button [mat-dialog-close]="true" color="primary">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }

    @if (data.type === 'danger') {
        <button mat-raised-button [mat-dialog-close]="true" color="warn">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }
    @if (data.type === 'danger-outline') {
        <button mat-stroked-button [mat-dialog-close]="true" color="warn">
            {{ data.confirmButtonLabel ?? 'Ok' }}
        </button>
    }
</div>
